import styled from 'styled-components';
import { device } from 'styles/breakpoints';

export const Step7Content = styled.div`
  > p:nth-child(2) {
    margin-bottom: 24px;
  }
  > div:nth-child(3) {
    margin-bottom: 24px;
    > span {
      font-weight: 500;
      &:last-child {
        margin-left: 10px;
      }
    }
  }
  @media ${device.tablet} {
    max-width: 400px;
    > p:nth-child(2) {
      margin-bottom: 18px;
    }
    > div:nth-child(3) {
      margin-bottom: 18px;
    }
    .react-datepicker__day-name,
    .react-datepicker__day,
    .react-datepicker__time-name {
      width: 1.4rem;
      line-height: 1.4rem;
    }
  }
`;

export const Step7Option = styled.div`
  margin-top: 20px;
  > span {
    font-weight: 500;
  }
  @media ${device.tablet} {
    margin-top: 10px;
  }
`;
